export const accentMap = {
  blue: { bg: "#e0ecff", fg: "#1d4ed8" },
  violet: { bg: "#ebe9ff", fg: "#6d28d9" },
  green: { bg: "#e5f8f2", fg: "#0f766e" },
  amber: { bg: "#fff4e0", fg: "#c2410c" },
  aqua: { bg: "#e0f7ff", fg: "#0ea5e9" },
  coral: { bg: "#ffe7e2", fg: "#dc2626" },
};

export const formatNumber = (value) => {
  if (value === null || value === undefined) return "0";
  const num = Number(value);
  if (Number.isNaN(num)) return value;
  return num.toLocaleString("es-EC");
};

export const formatDateTime = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleString("es-EC");
};

export const formatShortDate = (value) => {
  if (!value) return "";
  if (typeof value === "string") {
    const parts = value.split("-");
    return parts.length === 3 ? `${parts[2]}/${parts[1]}` : value;
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return `${String(date.getDate()).padStart(2, "0")}/${String(date.getMonth() + 1).padStart(2, "0")}`;
};

export const getAlertBadge = (level) => {
  switch (level) {
    case "danger":
      return "bg-danger";
    case "warning":
      return "bg-warning text-dark";
    case "info":
      return "bg-info text-dark";
    default:
      return "bg-success";
  }
};

export const describeFaltas = (row = {}) => {
  const faltas = [];
  if (row.sin_rol) faltas.push("Rol");
  if (row.sin_centro) faltas.push("Centro");
  return faltas.length ? faltas.join(", ") : "-";
};
